import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { DELIVERY_BACK } from '@pages/Delivery/focusKey';
import constate from 'constate';
import { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { delivery, DeliveryTextItem } from './text';
import { DeliveryParams } from './types';

const useDelivery = () => {
  const { treatmentId = '', deliveryMethod = 'visit' } = useParams<DeliveryParams>();

  const deliveryText = useMemo<DeliveryTextItem>(() => {
    switch (deliveryMethod) {
      default:
      case 'visit':
        return delivery.visit;
    }
  }, [deliveryMethod]);

  const { setFocus } = useFocusable();

  const setButtonFocus = useCallback(() => {
    if (deliveryMethod === 'visit') {
      setFocus(DELIVERY_BACK);
    }
  }, [deliveryMethod, setFocus]);

  const targetUrl = useMemo(() => {
    return `https://goodoc.onelink.me/7srm?af_dp=goodoc://app/untact/history/detail/${treatmentId}`;
  }, []);

  return {
    deliveryText,
    setButtonFocus,
    targetUrl
  };
};

export const [DeliveryProvider, useDeliveryContext] = constate(useDelivery);
